import React, { useLayoutEffect, useRef, useState } from 'react'
import { formatHoursOff, getValueFromResource } from '../../common/timeLiveFunction'
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { TOOLTIP_STYLE } from '../../common/TooltipStyle';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const TimeOffTypeLabel = ({ text }: { text: string }) => {
    const textRef = useRef<HTMLAnchorElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);
    

    useLayoutEffect(() => {
        const checkTruncation = () => {
            const el = textRef.current;
            if (el) {
                setIsTruncated(el.scrollWidth > el.clientWidth);
            }
        };

        checkTruncation();
        window.addEventListener('resize', checkTruncation);
        return () => window.removeEventListener('resize', checkTruncation);
    }, [text]);

    return (
        <a
            ref={textRef}
            className="timeOff-hourStatus"
            style={{
                paddingLeft: 16,
                display: 'block',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: isTruncated ? 'pointer' : 'default',
            }}
            data-tooltip-id={isTruncated ? 'tooltip-timeOffType' : undefined}
            data-tooltip-content={isTruncated ? text : undefined}
        >
            {text}
        </a>
    );
};
const TimeOffStatusGridView = (props: any) => {
    const { timeoffrequeststatusList, isShowTimeOffInDays, showConsumedHours } = props;
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { cultureInfoName } = useAppSelector((state) => state.globalState);

    return (
        <div>
            <div className='row' style={{ width: '100%' }}>
                {timeoffrequeststatusList.length > 0 && timeoffrequeststatusList.map((item: any, i: any) => (
                    <div className='col-md-3 col-sm-3 col-xs-12 timeOffStatusParent' key={i}>
                        <div className='timeOffStatusInfo'>

                            <div className="row" style={{ height: 64 }}>
                                <div className="col-md-10" style={{ marginTop: 24 }}>
                                    <TimeOffTypeLabel text={item.AccountTimeOffType} />
                                </div>
                                {/* <div className="col-md-6" style={{ marginTop: 12 }}>
                                    <span className="tsNavBarInfoLabel" style={{ fontSize: 14 }}>
                                        {t("Available")}
                                    </span>
                                    <div className="timeOffAvailableDays">
                                        {isShowTimeOffInDays ? (
                                            <span>{`${formatHoursOff(Number(item.AvailableDay), 2, cultureInfoName.toString())} Days`}</span>
                                        ) : (
                                            <span>{`${formatHoursOff(Number(item.Available), 2, cultureInfoName.toString())} Hours`}</span>
                                        )}
                                    </div>
                                </div> */}
                            </div>
                            <div className="timeOffStatus-Separator"></div>
                            <div className="timeOffStatus-FooterContainer">
                                <div className="timeOffStatus-Footer">
                                    <span className="timeOffConsumeLabel">
                                        {isShowTimeOffInDays ? (
                                            <span>{`${formatHoursOff(Number(item.AvailableDay), 2, cultureInfoName.toString())} Days`}</span>
                                        ) : (
                                            <span>{`${formatHoursOff(Number(item.Available), 2, cultureInfoName.toString())} Hours`}</span>
                                        )}
                                    </span>
                                    <div>
                                        <span className="timeOffConsumeValue">{t("Available")}</span>
                                    </div>
                                </div>
                                 {showConsumedHours && <div className="timeOffStatus-Footer">
                                    <span className="timeOffConsumeLabel">
                                        {isShowTimeOffInDays ? (
                                            <span>{`${formatHoursOff(Number(item.ConsumeDay), 2, cultureInfoName.toString())} Days`}</span>
                                        ) : (
                                            <span>{`${formatHoursOff(Number(item.Consume), 2, cultureInfoName.toString())} Hours`}</span>
                                        )}
                                    </span>
                                    <div>
                                        <span className="timeOffConsumeValue">{t("Consume")}</span>
                                    </div>
                                </div>}
                                <div className="timeOffStatus-Footer">
                                    <span className="timeOffEarnedLabel">
                                        {isShowTimeOffInDays ? (
                                            <span>{`${formatHoursOff(Number(item.EarnedDay), 2, cultureInfoName.toString())} Days`}</span>
                                        ) : (
                                            <span>{`${formatHoursOff(Number(item.Earned), 2, cultureInfoName.toString())} Hours`}</span>
                                        )}
                                    </span>
                                    <div>
                                        <span className="timeOffConsumeValue">{t("Earned")}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ))}
                {timeoffrequeststatusList.length === 0 &&
                    <div className='mt-4'>
                        <p className='noDataFound'>

                            {getValueFromResource('No Record Found', dispatch, t)}
                        </p>
                    </div>
                }
            </div>
            <ReactTooltip
                id="tooltip-timeOffType"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </div>
    )
}

export default TimeOffStatusGridView